import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconPlus = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 17} height={props.height || 16} viewBox="0 0 17 16" fill="none">
      <g id="Frame">
        <path
          id="Vector"
          d="M3.83398 8H13.1673"
          stroke={props.stroke || theme.colors.background.primary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M8.5 3.33331V12.6666"
          stroke={props.stroke || theme.colors.background.primary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </IconBase>
  )
}

export const IconPlusPrice = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 16} height={props.height || 16} viewBox="0 0 16 16" fill="none">
      <path
        d="M7.33399 8.33334H4.00065C3.81176 8.33334 3.65354 8.26934 3.52599 8.14134C3.39843 8.01334 3.33443 7.85511 3.33399 7.66667C3.33354 7.47822 3.39754 7.32 3.52599 7.192C3.65443 7.064 3.81265 7 4.00065 7H7.33399V3.66667C7.33399 3.47778 7.39799 3.31956 7.52599 3.192C7.65399 3.06445 7.81221 3.00045 8.00065 3C8.1891 2.99956 8.34754 3.06356 8.47599 3.192C8.60443 3.32045 8.66821 3.47867 8.66732 3.66667V7H12.0007C12.1895 7 12.348 7.064 12.476 7.192C12.604 7.32 12.6678 7.47822 12.6673 7.66667C12.6669 7.85511 12.6029 8.01356 12.4753 8.142C12.3478 8.27045 12.1895 8.33422 12.0007 8.33334H8.66732V11.6667C8.66732 11.8556 8.60332 12.014 8.47532 12.142C8.34732 12.27 8.1891 12.3338 8.00065 12.3333C7.81221 12.3329 7.65399 12.2689 7.52599 12.1413C7.39799 12.0138 7.33399 11.8556 7.33399 11.6667V8.33334Z"
        fill={theme.colors.text.primary}
      />
    </IconBase>
  )
}
